<script setup lang="ts">
import { LifeBuoy } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { useTutorialRegister } from '@/feature/tutorialAgent/useTutorialRegister'
import { useAssistantPanelStore } from '@/stores/assistantPanelStore'
import { useTranslateKey } from '@/lib/utils'
const { targetRef } = useTutorialRegister({
  id: 'help-button',
  label: 'Help button',
  role: 'button',
  priority: 1
})
const assistantPanelStore = useAssistantPanelStore()
const { translateKey } = useTranslateKey()

const toggleModal = () => {
  assistantPanelStore.isOpen = !assistantPanelStore.isOpen
}
</script>

<template>
  <div ref="targetRef" class="flex items-center">
    <Button
      data-testid="assistant-launcher-button"
      size="sm"
      variant="secondary"
      class="gap-2"
      @click="toggleModal"
    >
      <LifeBuoy class="h-4 w-4" />
      {{ translateKey('assistant') }}
    </Button>
  </div>
</template>
